module.exports = __webpack_public_path__ + "img/card_ip_stipulation54.87b5326e.svg";